import { Logo } from "./style";
import img from "../../../assets/images/DREIklangLogo_klein.png";


export const LogoComponent = () => {
  return <Logo src={img} />;
};
